import { render, staticRenderFns } from "./OwnerAppadvertisingadd.vue?vue&type=template&id=89df12f6&"
import script from "./OwnerAppadvertisingadd.vue?vue&type=script&lang=js&"
export * from "./OwnerAppadvertisingadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports